"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sme(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "36497701-cbc2-47d5-983a-8b688adaa229",
    x1: 74,
    y1: 80,
    x2: 164.31,
    y2: 170.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "sme-hi"), /*#__PURE__*/React.createElement("g", {
    id: "61f15802-e9b3-4f20-9e92-456f380f21ad",
    "data-name": "sme-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "28f760ba-0146-44a2-ba69-649d72452e0f",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "a8657d60-9ee0-4db3-bbd9-32a95383db87",
    "data-name": "Calls_Contacts_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "670a79b5-4425-450a-8f2c-d6cdbc426e14",
    "data-name": "PayG_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "720026b0-8007-4bab-9715-3eab81655222",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9d4f519c-b744-4e51-99ee-536e815248a6",
    "data-name": "My_Vodafone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d4b7540b-b157-4917-9cb5-09a182c58549",
    "data-name": "Settings_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e81e44ea-d78b-4c6a-b309-c1216f8eb132",
    "data-name": "User_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ca39e048-c898-4d4d-8100-3cad60752d81",
    "data-name": "Video_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ee74cebb-7b52-48c9-88ea-590b1f59f67b",
    "data-name": "Tutorials_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9a1b8dc8-fb00-4b96-a9ab-7fb2cf9c8b7c",
    "data-name": "Community_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4071b5ee-03ba-45b0-b04f-74512ccf2358",
    "data-name": "Entertainment_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2f2931ea-e779-4712-bc10-04b2f4c93a5f",
    "data-name": "Insurance_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fca27d18-07cc-40e9-b049-4389bfc5bf99",
    "data-name": "Photos_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "666bc15f-cb52-4f7a-bacb-96591eadd112",
    "data-name": "Pie_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4c6d3eb4-d4c0-4a67-8573-201096292fc7",
    "data-name": "Shopping_trolley_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "17e9d1f9-9263-432a-a5f3-75d162f1e3c5",
    "data-name": "Business_phone_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f4a7dfd0-8985-4575-ba1e-6e52a5ababe4",
    "data-name": "Bundles_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "59edd710-e584-49de-962e-f60118a5bfd6",
    "data-name": "Customer_care_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "797e3c6e-edf0-4b99-bf88-31a1367bd59f",
    "data-name": "Minutes_sms_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "30da3974-d778-42af-a04d-cd49561ae005",
    "data-name": "Bar_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ce6a2e3b-84e0-4836-ac70-3633f905f499",
    "data-name": "Line_chart_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0c32fad0-2e77-4550-a3d3-a54d7f16344b",
    "data-name": "Blog_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fe55694c-2750-435b-b066-2e9979828ee3",
    "data-name": "SoHo_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aed8d01f-e5a1-4f6d-8af9-8a2d6f5c9075",
    "data-name": "SME_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,28H164a8,8,0,0,1,8,8V156a16,16,0,0,1-16,16H36a16,16,0,0,1-16-16V36A8,8,0,0,1,28,28Z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 116,
    width: 56,
    height: 56,
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 116,
    width: 56,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 114,
    width: 56,
    height: 2,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,170H36a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H156a16,16,0,0,0,16-16v-2A16,16,0,0,1,156,170Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,156V134l-32-32H52l70,70h34A16,16,0,0,0,172,156Z",
    opacity: 0.2,
    fill: "url(#36497701-cbc2-47d5-983a-8b688adaa229)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 24,
    height: 24,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 56,
    width: 24,
    height: 24,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 56,
    width: 24,
    height: 24,
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 56,
    width: 24,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 56,
    width: 24,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 56,
    width: 24,
    height: 2,
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,104H54a2,2,0,0,1,0-4h84a2,2,0,0,1,0,4Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 20,
    width: 160,
    height: 20,
    rx: 4,
    ry: 4,
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,38H20a4,4,0,0,1-4-4v2a4,4,0,0,0,4,4H172a4,4,0,0,0,4-4V34A4,4,0,0,1,172,38Z",
    opacity: 0.12
  })))))))))))))))))))))))))));
}

var _default = ic_sme;
exports.default = _default;